import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./PriorPrice.css";
var styles = { "container": "a30fa5", "hm": "e754b4", "northstar-small": "b4f91c", "northstar-large": "caf866", "priorPrice": "b561e1" };
const PriorPrice = ({ priorPrice, priorPriceLabel, variant = 'hm' }) => {
    const Tag = variant === 'hm' ? BodyText : MetaText;
    if (priorPrice && priorPriceLabel) {
        return (React.createElement("p", { className: cn(styles.container, styles[variant]) },
            React.createElement(Tag, { Tag: "span", hasEllipsis: true, isMarginless: true },
                priorPriceLabel,
                ":"),
            React.createElement(Tag, { className: styles.priorPrice, Tag: "span", isMarginless: true }, priorPrice)));
    }
    return null;
};
export default PriorPrice;
//# sourceMappingURL=PriorPrice.js.map